import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import MainLayout from "../containers/layout/components/mainlayout";
import AboutUs from "../pages/components/aboutus";
import ContactUs from "../pages/components/contactus";
import LatestArticles from "../pages/components/articles";
import CampaignLayout from "../containers/layout/components/campaignlayout";
import App from "../App";
import LoginLayout from "../containers/layout/components/loginlayout";
import ProtectedRoute from "./protectedroute";
import UserLayout from "../containers/layout/components/userlayout";
import Dashboard from "../components/user/body/dashboard/dashboard";
import Campaigns from "../components/user/body/campaigns/campaigns";
import SiteAndAppAcceptor from "../components/user/body/siteandappacceptor/siteandappacceptor";
import TijarAssistant from "../components/user/body/tijarassistant/tijarassistant";
import PublisherLayout from "../containers/layout/components/publisherlayout";
import PublisherDashboard from "../components/publisher/body/dashboard/dashboard";
import AdStations from "../components/publisher/body/adstations/adstations";

const PageRoutes = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={"/about-us"} element={
                    <MainLayout><AboutUs/></MainLayout>
                }/>
                <Route path={"/contact-us"} element={
                    <MainLayout><ContactUs/></MainLayout>
                }/>
                <Route path={"/articles"} element={
                    <MainLayout><LatestArticles/></MainLayout>
                }/>
                <Route path={"/matching-campaign"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={0}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/banner-ads"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={1}/>
                    </ProtectedRoute>
                }/>
                {/*<Route path={"/advertisements-report-ads"} element={
                    <ProtectedRoute target={"/login"}>
                        <CampaignLayout id={2}/>
                    </ProtectedRoute>
                }/>*/}
                <Route path={"/google-ads"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={3}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/video-ads"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={4}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/product-ads"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={5}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/social-media-ads/instagram/view/post"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={6}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/social-media-ads/instagram/view/story"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={7}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/social-media-ads/instagram/pricing/post/content"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={8}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/social-media-ads/instagram/pricing/post/influencer"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={9}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/social-media-ads/telegram/post/create"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={10}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/social-media-ads/telegram/post/forward"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={11}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/social-media-ads/provincial-teaser"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <CampaignLayout id={12}/>
                    </ProtectedRoute>
                }/>
                <Route path={"/login"} element={
                    localStorage.getItem("loggedIn") ?
                        <Navigate to={`/${localStorage.getItem('userType')}/dashboard`}/> : <LoginLayout/>
                }/>
                <Route path={"/user/dashboard"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <UserLayout><Dashboard/></UserLayout>
                    </ProtectedRoute>
                }/>
                <Route path={"/user/campaigns"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <UserLayout><Campaigns/></UserLayout>
                    </ProtectedRoute>
                }/>
                <Route path={"/user/site-and-app-acceptor"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <UserLayout><SiteAndAppAcceptor/></UserLayout>
                    </ProtectedRoute>
                }/>
                <Route path={"/user/tijar-assistant"} element={
                    <ProtectedRoute userAccess="user" target={"/login"}>
                        <UserLayout><TijarAssistant/></UserLayout>
                    </ProtectedRoute>
                }/>
                <Route path={"/publisher/dashboard"} element={
                    <ProtectedRoute userAccess="publisher" target={"/login"}>
                        <PublisherLayout><PublisherDashboard/></PublisherLayout>
                    </ProtectedRoute>
                }/>
                <Route path={"/publisher/ad-stations"} element={
                    <ProtectedRoute userAccess="publisher" target={"/login"}>
                        <PublisherLayout><AdStations/></PublisherLayout>
                    </ProtectedRoute>
                }/>
                <Route path={"/"} element={
                    <MainLayout><App/></MainLayout>
                }/>
                <Route path={"*"} element={<Navigate to={'/'} replace/>}></Route>
            </Routes>
        </BrowserRouter>
    );
}

export default PageRoutes;